import React, {lazy, Suspense } from 'react';
import Dashboard from '../../components/Dashboard/Dashboard';
import LazyLoader from '../../components/MasterLayout/LazyLoader';
const OrderDetails = lazy(()=>import('../../components/Dashboard/MyOrder/OrderDetails'))

const OrderDetailsPage = () => {
    return (
        <Dashboard>
            <Suspense fallback={<LazyLoader/>}>
                <OrderDetails/>
            </Suspense>
        </Dashboard>
    );
};

export default OrderDetailsPage;